import React, { useEffect, useState } from 'react';
import AdminNavbar from './Navbar/AdminNavbar';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col } from "antd";
import { AiOutlineDollar, AiOutlineFileText, AiOutlineBarChart, AiOutlineDollarCircle } from "react-icons/ai";
import { MdAccountBalance, MdReceipt, MdAttachMoney, MdDashboard } from "react-icons/md";
import axios from "axios";
import { FaMountain } from 'react-icons/fa';
import { AdminEmployeeTodayExpense, AdminMineList, AdminTodayExpense, AdminTodayMIneExpense, AdminTotalExpense, AdminYearAllExpense, AdminYearEmployeeExpense, AdminYearEmployeeTodayExpense, AdminYearMineExpense } from './Api/All_Api';
import { toast } from 'react-toastify';
import TitleNavbar from './Navbar/TitleNavbar';
import image from "./Assets/logo.png";
import bill from "./Assets/bill.png";
import yearbill from "./Assets/summary1.png";
import expensetoday from "./Assets/expeneses.png";
import yearexpense from "./Assets/yearly.png";


const Dashboard = () => {
const navigate = useNavigate();
  const sessionYear = sessionStorage.getItem('sessionYear');
  // const year = sessionYear
  const year = 2024
  console.log("session year===>>",year);
  const branchId = sessionStorage.getItem('branchId');

  useEffect(() => {
    //---------------------------------Disabled back button-------------------------------
    window.history.pushState(null, null, window.location.href);

    const handleBackButton = (event) => {
      event.preventDefault();
      window.history.forward();
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  useEffect(() => {
    if (!sessionYear) {
      sessionStorage.clear();
      navigate('/')
    }
  },[])
  const [mines, setMines] = useState([]);
 const[todayRecievedAmount,setTodayRecievedAmount]=useState("");
 const[todayBillAmount,setTodayBillAmount]=useState("");
 const[yearRecievedAmount,setYearRecievedAmount]=useState("");
 const[yearBillAmount,setYearBillAmount]=useState("");
 const[yearPendingAmount,setYearPendingAmount]=useState("");

 const [todayExpenses, setTodayExpenses] = useState(0); // Change "" to 0
 const [todayEmpExpenses, setTodayEmpExpenses] = useState(0);
  const [yearlyExpenses, setYearlyExpenses] = useState("");

  const [yearlyEmpExpenses, setYearlyEmpExpenses] = useState("");
  const [todayTotal, setTodayTotal] = useState(null);



  useEffect(() => {
   fetchMines();
   TodayData();
   YearTotal();
   TodayMineExpense();
   YearMineExpense();
   TodayEmployeeExpense();
   YearEmployeeExpense();
  }, []);
const fetchMines = async() =>{
  try{
  const response = await axios.get(`${AdminMineList}?branchId=${branchId}&accYear=${year}`);
  if(response.data){
  setMines(response.data);

  }}
  catch(error){
      console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
  }

}
const TodayData = async() =>{
  try{
  const response = await axios.get(`${AdminTodayExpense}?branchId=${branchId}&accYear=${year}`);
  if (response.data !== undefined && response.data !== null) {
    console.log("Today Expenses:", response.data);  // Log API response
     setTodayExpenses(response.data);
  } else {
    console.warn("API returned null or undefined data");
  }}
  catch(error){
      console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
  }

}

const YearTotal = async() =>{
  try{
  const response = await axios.get(`${AdminYearAllExpense}?branchId=${branchId}&accYear=${year}`);
  if(response.data){
 setYearlyExpenses(response.data);

  }}
  catch(error){
      console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
  }
}
const TodayEmployeeExpense = async() =>{
  try{
  const response = await axios.get(`${AdminEmployeeTodayExpense}?branchId=${branchId}&accYear=${year}`);
  if(response.data){
  setTodayEmpExpenses(response.data);


  }}

  catch(error){
      console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
  }

}
const YearEmployeeExpense = async() =>{
  try{
  const response = await axios.get(`${AdminYearEmployeeExpense}?branchId=${branchId}&accYear=${year}`);
  if(response.data){
  setYearlyEmpExpenses(response.data);

  }}
  catch(error){
      console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
  }

}
const YearMineExpense = async() =>{
  try{
  const response = await axios.get(`${AdminYearMineExpense}?branchId=${branchId}&accYear=${year}`);
  if (Array.isArray(response.data) && response.data.length > 0) {
    const data = response.data[0]; // Extract the first object from the array
    
    setYearRecievedAmount(data.yearlyReceivedAmount);
    setYearBillAmount(data.yearlyBillAmount);
    setYearPendingAmount(data.yearlyPendingBill);
  } else {
    console.warn("Unexpected API response format:", response.data);
  }}
  catch(error){
      console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
  }

}
const TodayMineExpense = async() =>{
  try{
  const response = await axios.get(`${AdminTodayMIneExpense}?branchId=${branchId}&accYear=${year}`);
  if (Array.isArray(response.data) && response.data.length > 0) {
    const data = response.data[0]; // Extract the first object from the array
    setTodayBillAmount(data.totalBillingAmount);
    setTodayRecievedAmount(data.totalReceivedAmount);
  } else {
    console.warn("Unexpected API response format:", response.data);
  }}
  catch(error){
      console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
  }

}
//===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================


  return (
    <>
      <AdminNavbar />

      {/* <div>
         <h2 className="text-center mt-md-4 mt-2 mb-3 m-0 p-0" style={{ color: 'maroon' }}>
          Dashboard
        </h2> 

      </div> */}
      {/* <div className="p-0 m-0">
 
      <Row gutter={[16, 16]}>
        {mines.map((mine) => (
          <Col  xs={12} sm={8} md={6} key={mine.id}>
            <Card  className="shadow-lg"  title={<><FaMountain  size={24}  /> {mine.name}</>}  style={{ backgroundColor: '	#FFDAB9' }}  bordered>
              <p  className="text-md"><strong>Bill:</strong> {mine.bill}</p>
              <p  className="text-md"><strong>Receipts:</strong> {mine.receipts}</p>
            </Card>
          </Col>
        ))}
      </Row>

     
      <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
        <Col xs={12} sm={8} md={6}>
          <Card  className="shadow-lg" title={<><AiOutlineBarChart size={24}  /> Today's All Mines</>}   style={{ backgroundColor: '	#FFDAB9' }} bordered>
            <p className="text-md">Total Bill : {todayBillAmount} </p>
            <p className="text-md">Total Receipts : {todayRecievedAmount}</p>
          </Card>
        </Col>

        <Col xs={12} sm={8} md={6}>
          <Card className="shadow-lg" title={<><AiOutlineDollarCircle size={24}  /> Today's Expenses</>}   style={{ backgroundColor: '	#FFDAB9' }} bordered>
            <p className="text-md">Expenses : {todayExpenses}</p>
            <p className="text-md">Employee Expenses :{todayEmpExpenses}</p>
          </Card>
        </Col>

        <Col xs={12} sm={8} md={6}>
          <Card className="shadow-lg" title={<><AiOutlineDollarCircle size={24}  /> 2024-25 Expenses</> }  style={{ backgroundColor: '	#FFDAB9' }}  bordered>
            <p className="text-md">Expenses: {yearlyExpenses}</p>
            <p className="text-md">Employee Expenses: {yearlyEmpExpenses}</p>
          </Card>
        </Col>

        <Col xs={12} sm={8} md={6}>
          <Card className="shadow-lg" title={<><AiOutlineBarChart size={24}/> 2024-25</>} bordered  style={{ backgroundColor: '	#FFDAB9' }}>
            <p className="text-md">Billing : {yearBillAmount}</p>
            <p className="text-md">Receipts : {yearRecievedAmount}</p>
            <p className="text-md">Pending : {yearPendingAmount}</p>
          </Card>
        </Col>
      </Row>
    </div> */}

    <div className="p-0 m-0">
        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
              <span className="px-md-5"  style={{ flexGrow: 1 }}>
                <MdDashboard /> &nbsp;
               Dashboard
                          </span>
                          <span >
            <TitleNavbar/>
            </span>
              </div>
            </div>
            


  {/* Other Dashboard Tiles */}
  <div className="custom-container py-4">
  {/* Other Dashboard Tiles */}
  <Row gutter={[16, 16]} justify="center" style={{ marginTop: "20px" }}>
    {[ 
      { 
        title: "Today's Summary", 
        image: bill, 
        content: [
          { label: "Total Bill", value: todayBillAmount },
          { label: "Total Receipts", value: todayRecievedAmount }
        ], 
        background: "linear-gradient(135deg,rgb(207, 111, 87), #FCB045)" 
      },
      { 
        title: "Today's Expenses", 
        image: expensetoday, 
        content: [
          { label: "Expenses", value: todayExpenses },
          { label: "Employee Expenses", value: todayEmpExpenses }
        ], 
        background: "linear-gradient(135deg,rgb(159, 221, 162), #43A047)" 
      },
      { 
        title: "2024-25 Expenses", 
        image: yearexpense, 
        content: [
          { label: "Expenses", value: yearlyExpenses },
          { label: "Employee Expenses", value: yearlyEmpExpenses }
        ], 
        background: "linear-gradient(135deg,rgb(170, 214, 250), #1E88E5)" 
      },
      { 
        title: "2024-25 Summary", 
        image: yearbill, 
        content: [
          { label: "Billing", value: yearBillAmount },
          { label: "Receipts", value: yearRecievedAmount },
          { label: "Pending", value: yearPendingAmount }
        ], 
        background: "linear-gradient(135deg,rgb(223, 173, 231), #8E24AA)" 
      }
    ].map((tile, index) => (
      <Col xs={24} sm={12} md={8} lg={6} key={index}>
        <Card className="shadow-lg interactive-card" bordered style={{ background: tile.background }}>
          <div className="card-content">
          
            <div className="card-header">
              <img src={tile.image} alt={tile.title} className="card-image" /> &nbsp;&nbsp;&nbsp;
              <h5>{tile.title}</h5>
            </div>
          
            <div className="card-details">
              {tile.content.map((item, idx) => (
                <p key={idx}><strong>{item.label}:</strong> {item.value}</p>
              ))}
            </div>
          </div>
        </Card>
      </Col>
    ))}
  </Row>

  {/* Mines Section */}
  <Row gutter={[16, 16]} justify="center" style={{ marginTop: "30px" }}>
    {mines.map((mine) => (
      <Col xs={24} sm={12} md={8} lg={6} key={mine.id}>
        <Card
          className="shadow-lg interactive-card"
          bordered
          style={{ background: "linear-gradient(135deg,rgb(185, 195, 221),rgb(40, 83, 134))", color: "white" }}
        >
          <div className="card-content">
    
            <div className="card-header">
              <img src={image} alt="Mine" className="card-image" />&nbsp;&nbsp;&nbsp;
              <h5>{mine.mineName}</h5>
            </div>
        
            <div className="card-details">
              <p><strong>Bill:</strong> {mine.totalBillAmount}</p>
              <p><strong>Receipts:</strong> {mine.totalReceivedAmount}</p>
            </div>
          </div>
        </Card>
      </Col>
    ))}
  </Row>



  {/* Styles */}
  <style jsx>{`
    .custom-container {
  max-width:1100px;
  margin: auto;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  background-color: white;
}

.interactive-card {
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  height: 210px; /* Increased height */
  width: 220px;  /* Uniform width for all cards */
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.interactive-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  font-size: 18px;
}

.card-header h4 {
  margin-left: 10px;
  font-size: 16px;
  word-wrap: break-word;
}

.card-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 8px;
}

.card-details {
  padding: 5px;
  text-align: left;
  font-size: 14px;
  overflow: hidden;
  
}

.card-details p {
  font-size: 14px;
  font-weight: 500;
  color: white;
  margin: 5px 0;
  word-wrap: break-word; /* This ensures that long words will break and wrap to the next line */
  white-space: normal;  /* Allow text to wrap onto the next line instead of overflowing */
  text-overflow: ellipsis; /* Add ellipsis if the text overflows */
}

.card-details p strong {
  font-weight: bold;
}

@media screen and (max-width: 767px) {
  .card-details p {
    font-size: 12px;
  }

  .card-header h4 {
    font-size: 14px;
  }
  `}</style>
</div>
</div>
  
    </>
  );
}

export default Dashboard;
